/* AOF - an angler's Rod Finder list, drawn on the shop: /pages/your-rods.

   Ben, 2026-10-04: "A text email with link to the page on the website site
   for every response allows hopeful inclusion in their actual inbox with text
   email... Dynamic page even better to save adding 100's of unique pages".

   One page for every list. It reads the list's key, asks the order door for
   that list, and draws it the way the approved HTML letter drew it: the
   title, About Me, his words, a card for each recommendation with its tab,
   the gold "My pick" box, the thank-you code in its box, his name, and "Not
   quite right?" last.

   Every word on the page arrives as data and goes on with textContent, so
   nothing in a list can become markup here. The key comes in the link's
   #fragment, which never reaches a server; layout/theme.liquid takes it off
   the address before the shop's own scripts load, and leaves it in
   window.aofRodList and this browser's storage for this to read.
   Markup: sections/main-rod-list.liquid. Styles: the YOUR RODS block of
   component-aof-design-system.css. */
(function () {
  if (!window.customElements || customElements.get('aof-rod-list')) return;

  var KEY = /^[a-z0-9]{16}$/;
  var STORE = 'aof-rod-list';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null && text !== '') n.textContent = String(text);
    return n;
  }

  // His words as the letter sets them: a blank line between paragraphs, a
  // single line break kept as one.
  function paras(text, cls) {
    var out = [];
    String(text || '').trim().split(/\n\s*\n/).forEach(function (chunk) {
      chunk = chunk.trim();
      if (!chunk) return;
      var p = el('p', cls);
      chunk.split('\n').forEach(function (line, i) {
        if (i) p.appendChild(document.createElement('br'));
        p.appendChild(document.createTextNode(line));
      });
      out.push(p);
    });
    return out;
  }

  function arrow() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.8');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var a = document.createElementNS(ns, 'path');
    a.setAttribute('d', 'M5 12h14');
    var b = document.createElementNS(ns, 'path');
    b.setAttribute('d', 'm13 6 6 6-6 6');
    svg.appendChild(a);
    svg.appendChild(b);
    return svg;
  }

  function storage(name) {
    try {
      return window[name] || null;
    } catch (e) {
      return null;            // storage refused outright (cookies blocked)
    }
  }

  function stored(name) {
    var s = storage(name);
    if (!s) return null;
    try {
      var got = JSON.parse(s.getItem(STORE) || 'null');
      return got && KEY.test(got.l || '') ? got : null;
    } catch (e) {
      return null;
    }
  }

  function fromHash() {
    var q = {};
    String(location.hash || '').slice(1).split('&').forEach(function (kv) {
      var i = kv.indexOf('=');
      if (i > 0) {
        try {
          q[kv.slice(0, i)] = decodeURIComponent(kv.slice(i + 1));
        } catch (e) { /* a mangled pair is no key */ }
      }
    });
    return KEY.test(q.l || '') ? { l: q.l, p: q.p || '' } : null;
  }

  // The key theme.liquid kept for this load first, then the address (if
  // that script did not run), then this tab, then this browser - so a
  // reload, or coming back to the page from history, still finds the list.
  function theKey() {
    var w = window.aofRodList;
    if (w && KEY.test(w.l || '')) return w;
    return fromHash() || stored('sessionStorage') || stored('localStorage');
  }

  function table(rows, cls) {
    var t = el('table', cls);
    var body = el('tbody');
    rows.forEach(function (r) {
      var tr = el('tr');
      var th = el('th', '', r[0]);
      th.setAttribute('scope', 'row');
      tr.appendChild(th);
      tr.appendChild(el('td', '', r[1]));
      body.appendChild(tr);
    });
    t.appendChild(body);
    return t;
  }

  function headFor(r) {
    return r.price ? r.name + ' (' + r.price + ')' : r.name;
  }

  function button(url, label, cls) {
    var a = el('a', 'button aof-yr__btn' + (cls ? ' ' + cls : ''), label);
    a.href = url;
    a.appendChild(arrow());
    return a;
  }

  class AofRodList extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      this._head = this.querySelector('[data-aof-yr-title]');
      this._sub = this.querySelector('[data-aof-yr-subtitle]');
      this._status = this.querySelector('[data-aof-yr-status]');
      this._list = this.querySelector('[data-aof-yr-list]');
      var d = this.dataset;
      var key = theKey();
      if (!key || !d.api) {
        this.say(d.unknownHead, d.unknownText);
        return;
      }
      var url = d.api + '?l=' + encodeURIComponent(key.l) +
        (key.p ? '&p=' + encodeURIComponent(key.p) : '') +
        '&cb=' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      var self = this;
      // A plain GET with no headers of its own and no cookies: the one call
      // the order door answers for this site, and never with a preflight.
      fetch(url, { credentials: 'omit' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (!data || !data.ok || !data.list) {
            self.say(d.unknownHead, d.unknownText);
            return;
          }
          self.draw(data.list);
        })
        .catch(function () {
          self.say(d.failedHead, d.failedText);
        });
    }

    say(head, text) {
      var box = this._status;
      if (!box) return;
      box.textContent = '';
      box.appendChild(el('p', 'aof-yr__status-head', head));
      box.appendChild(el('p', 'aof-yr__status-text', text));
      box.hidden = false;
      if (this._list) this._list.hidden = true;
    }

    draw(L) {
      var self = this;
      if (L.title && this._head) this._head.textContent = L.title;
      if (L.subtitle && this._sub) {
        this._sub.textContent = L.subtitle;
        this._sub.hidden = false;
      }
      var out = document.createDocumentFragment();
      var words = [];

      // Words between rods - the greeting, the code line, the sign-off - go
      // in one card together, never a card per paragraph, as in the letter.
      function letter() {
        if (!words.length) return;
        var card = el('div', 'aof-yr__card aof-yr__words');
        words.forEach(function (n) { card.appendChild(n); });
        out.appendChild(card);
        words = [];
      }

      // About Me straight under the title, before the letter (Ben,
      // 2026-09-28: "move the about me section after that and then I can go
      // into recommendation one").
      if (L.about) out.appendChild(this.about(L.about));
      (L.blocks || []).forEach(function (b) {
        if (b.kind === 'para') {
          words = words.concat(paras(b.text));
          return;
        }
        if (b.kind === 'code') {
          words = words.concat(self.code(b));
          return;
        }
        letter();
        if (b.kind === 'rod') out.appendChild(self.rod(b, L));
        else if (b.kind === 'pick') out.appendChild(self.pick(b, L));
      });
      if (L.signoff) words.push(el('p', 'aof-yr__signoff', L.signoff));
      letter();
      // "Not quite right?" is the last card of all (Ben, 2026-09-28: "Put it
      // at the bottom of the email, obviously").
      if (L.check) out.appendChild(this.check(L.check));

      this._list.textContent = '';
      this._list.appendChild(out);
      this._list.hidden = false;
      this._status.hidden = true;
    }

    about(a) {
      var card = el('div', 'aof-yr__card aof-yr__about');
      if (this.dataset.portrait) {
        var face = el('div', 'aof-yr__portrait');
        var img = el('img');
        img.src = this.dataset.portrait;
        img.alt = this.dataset.portraitAlt || '';
        img.width = 400;
        img.height = 400;
        img.decoding = 'async';
        face.appendChild(img);
        card.appendChild(face);
      }
      var body = el('div', 'aof-yr__about-body');
      body.appendChild(el('h2', 'aof-h2-editorial aof-h2-editorial--compact aof-yr__card-head', a.head));
      paras(a.text).forEach(function (p) { body.appendChild(p); });
      if (a.url && a.link) {
        var link = el('a', 'aof-yr__about-link', a.link);
        link.href = a.url;
        link.appendChild(arrow());
        body.appendChild(link);
      }
      card.appendChild(body);
      return card;
    }

    code(b) {
      var out = paras(b.before);
      var box = el('div', 'aof-yr__code');
      box.appendChild(el('p', 'aof-yr__code-value', b.code));
      if (b.after) box.appendChild(el('p', 'aof-yr__code-after', b.after));
      out.push(box);
      return out;
    }

    tabs(label, star, pickLabel) {
      var row = el('div', 'aof-yr__tabs');
      if (label) row.appendChild(el('span', 'aof-yr__tab', label));
      if (star) {
        var gold = el('span', 'aof-yr__tab aof-yr__tab--pick');
        var s = el('span', 'aof-yr__star', '★︎');
        s.setAttribute('aria-hidden', 'true');
        gold.appendChild(s);
        gold.appendChild(document.createTextNode(pickLabel || ''));
        row.appendChild(gold);
      }
      return row;
    }

    buttons(r, L) {
      var row = el('div', 'aof-yr__buttons');
      if (r.url) row.appendChild(button(r.url, L.button));
      // His pink, the letter's one accent, so it reads as the other action.
      if (r.order) row.appendChild(button(r.order, L.order_label, 'aof-yr__btn--order'));
      return row;
    }

    item(r, head, text, L) {
      var box = el('div', 'aof-yr__item' + (r.image ? ' aof-yr__item--photo' : ''));
      box.appendChild(el('h2', 'aof-h2-editorial aof-h2-editorial--compact aof-yr__rod-head', head));
      if (r.image) {
        // The photo goes to the rod's page too; the button under the words
        // is the one a keyboard or a screen reader is given.
        var photo = el(r.url ? 'a' : 'div', 'aof-yr__photo');
        if (r.url) {
          photo.href = r.url;
          photo.tabIndex = -1;
          photo.setAttribute('aria-hidden', 'true');
        }
        var img = el('img');
        img.src = r.image;
        img.alt = r.name || '';
        img.decoding = 'async';
        photo.appendChild(img);
        box.appendChild(photo);
      }
      var main = el('div', 'aof-yr__main');
      if (r.specs && r.specs.length) main.appendChild(table(r.specs, 'aof-yr__specs'));
      paras(text).forEach(function (p) { main.appendChild(p); });
      if (r.note) main.appendChild(el('p', 'aof-yr__note', r.note));
      if (r.url || r.order) main.appendChild(this.buttons(r, L));
      box.appendChild(main);
      return box;
    }

    rod(b, L) {
      var self = this;
      var wrap = el('div', 'aof-yr__rec');
      wrap.appendChild(this.tabs(b.tab, b.star, L.pick_label));
      var card = el('div', 'aof-yr__card aof-yr__rod');
      var rods = b.rods || [];
      if (!rods.length) {
        // A one-off item or a heading of his with no rod under it.
        if (b.head) card.appendChild(el('h2', 'aof-h2-editorial aof-h2-editorial--compact aof-yr__rod-head', b.head));
        paras(b.text).forEach(function (p) { card.appendChild(p); });
      }
      rods.forEach(function (r, i) {
        // A second rod under one heading shares the card, below a rule.
        card.appendChild(self.item(r, i ? headFor(r) : (b.head || headFor(r)), i ? '' : b.text, L));
      });
      wrap.appendChild(card);
      return wrap;
    }

    pick(b, L) {
      // The gold box at the foot of the rods: his reason and its button, no
      // second photo - the rod's own card above already has one.
      var wrap = el('div', 'aof-yr__rec aof-yr__rec--pick');
      wrap.appendChild(this.tabs('', true, b.label || L.pick_label));
      var card = el('div', 'aof-yr__card aof-yr__pick');
      if (b.head) card.appendChild(el('h2', 'aof-h2-editorial aof-h2-editorial--compact aof-yr__rod-head', b.head));
      paras(b.text).forEach(function (p) { card.appendChild(p); });
      var r = (b.rods || [])[0];
      if (r) {
        if (r.note) card.appendChild(el('p', 'aof-yr__note', r.note));
        if (r.url || r.order) card.appendChild(this.buttons(r, L));
      }
      wrap.appendChild(card);
      return wrap;
    }

    check(c) {
      var card = el('div', 'aof-yr__card aof-yr__check');
      card.appendChild(el('h2', 'aof-h2-editorial aof-h2-editorial--compact aof-yr__card-head', c.head));
      var rows = c.rows || [];
      paras([c.text, rows.length ? c.lead : ''].filter(Boolean).join(' '))
        .forEach(function (p) { card.appendChild(p); });
      if (rows.length) card.appendChild(table(rows, 'aof-yr__answers'));
      return card;
    }
  }

  customElements.define('aof-rod-list', AofRodList);
})();
